// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5033":"css/app.6674","9723":"css/admin-app.6674"}[chunkId] + ".css";
};